module.exports = __webpack_public_path__ + "static/media/MartinaMagurova.031ce97b.jpg";